export default "__VITE_ASSET__uwQLeAbg__"